<div soho-busyindicator style="flex-direction: column"
    [text]="'BuildingReportList' | translate"
    [displayDelay]="20"
    [timeToComplete]="busyTimeOut">
  <div class="form-layout-compact">
    <ng-container *ngIf="true then REPORT_LIST"></ng-container>
    <ng-container *ngIf="true then INACCESSIBLE_ITEMS"></ng-container>
  </div>
</div>

<ng-template #REPORT_LIST>
  <div class="lm-flex-field-set-header">
    <div data-automation-id="lm-report-security-items-title" class="fieldset-title">{{'Reports' | translate }}
      <lm-mouse-over-text data-automation-id="lm-report-security-items-info" [mouseOverTextContents]="'DeliveredReportHelp' | translate"></lm-mouse-over-text></div>
  </div>
  <div id="lm-report-sec-list">
    <lm-reports-security-list *ngIf="displayDataGrid"
        [reportsArray]="reportsArray"
        uniqueId="reportSecurity"
        (notAccessibleClicked)="onNotAccessibleClicked($event)"
    ></lm-reports-security-list>
  </div>
</ng-template>

<ng-template #INACCESSIBLE_ITEMS>
  <div class="lm-flex-column-responsive-container">
    <div class="lm-flex-field-set-header">
      <div data-automation-id="lm-report-security-inaccessible-items-title" class="fieldset-title">{{'InaccessibleItems' | translate }}
        <lm-mouse-over-text data-automation-id="lm-report-security-inaccessible-items-info" [mouseOverTextContents]="'InaccessibleReportItemsHelp' | translate"></lm-mouse-over-text></div>

    </div>
    <soho-listview #SohoListView_InaccessibleItems data-automation-id="lm-report-security-inaccessible-items-listview"
        selectable='true'
        disableItemDeactivation="'true'">
      <li soho-listview-item *ngFor="let item of notAccessibleItemsKeys; index as i">
        <div class="lm-flex-row-container-no-wrap">
          <span attr.data-automation-id="inaccessible-item-{{item}}" class="font-size-sm lm-bold">{{item}}</span>
          <span *ngIf="notAccessibleItems[item].length > 1" class="font-size-sm" style="width:100%; margin-left: 8px;"> ({{notAccessibleItems[item]}})</span>
          <span *ngIf="!notAccessibleItems[item]">
              <svg attr.data-automation-id="lm-report-security-inaccessible-item-alert-{{item}}"class="icon icon-alert lm-alert"
                  soho-tooltip [content]="'InvalidInaccessibleReportItemAlert' | translate"><use xlink:href="#icon-alert"></use></svg>
          </span>
          <ng-template #elseTitle>{{notAccessibleItems[item]}}</ng-template>
          <span class="lm-flex-row-container-no-wrap-right ">
                        <button soho-button="tertiary" icon="delete" (click)="onInaccessibleItemRemove(item)" attr.data-automation-id="lm-report-security-inaccessible-item-delete-btn-{{item}}">{{'Delete' | translate}}</button>
                    </span>
        </div>
      </li>
    </soho-listview>
  </div>
</ng-template>